import CommonSelectBox, { SelectBoxProps } from '@atoms/SelectBox';

export default function SelectBox({ ...props }: SelectBoxProps) {
  return <CommonSelectBox isPipeline asString {...props} />;
}
